<template>
  <div>
    <div v-if="hasServices" class="flex flex-col divide-y">
      <slot v-bind="{ filteredServices }"></slot>
    </div>
    <div v-else class="p-3">
      <div
        class="flex bg-gray-50 justify-center p-2 items-center rounded border text-sm text-gray-500"
      >
        {{ noAvailMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import { getToday } from "@/moment-tz.js";

export default {
  props: {
    params: {
      type: Object,
      default: () => {
        return {
          services: [],
        };
      },
    },
    search: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    noAvailMessage() {
      if (!this.params) return;
      if (!this.params?.settings?.no_avail_message) return "No availabilities";
      return this.params.settings.no_avail_message;
    },
    isSamedayOpen() {
      return (
        this.$store?.state?.config?.samedayOpen ||
        this.search?.sameday_open === "1"
      );
    },
    timezone() {
      return this.params?.settings?.timezone;
    },
    today() {
      return getToday(this.timezone)[1];
    },
    includeServices() {
      return this.$store.getters.includeServices;
    },
    filteredServices() {
      if (!this.params?.services) return;

      if (this.includeServices.length > 0) {
        let results = (this.params?.services || [])
          ?.filter((el) => (el?.availability || [])?.length > 0)
          ?.filter((el) =>
            this.includeServices?.includes((el?.service?.id || "").toString())
          );

        if (!this.isSamedayOpen) return results;

        return results?.filter((el) =>
          el?.availability?.find((date) => date?.date === this.today)
        );
      }

      if (this.isSamedayOpen) {
        return (this.params?.services || [])
          ?.filter((el) => (el?.availability || [])?.length > 0)
          ?.filter((el) =>
            el?.availability?.find((date) => date?.date === this.today)
          );
      }

      return (this.params?.services || [])?.filter(
        (el) => (el?.availability || [])?.length > 0
      );
    },
    hasServices() {
      if (!this.filteredServices) return;
      return (this.filteredServices || [])?.length > 0;
    },
  },
  watch: {
    hasServices: {
      handler(value) {
        if (!this.isSamedayOpen) return;

        if (!value) {
          this.$emit("has:services", this.params?.location_id);
        }
      },
      immediate: true,
    },
  },
};
</script>
